import { Img } from 'react-progressive-loader'

const ImageProgressive = Img

export default ImageProgressive
